// extracted by mini-css-extract-plugin
module.exports = {"wordDetails":"EndScreen_wordDetails__38NMp"};